export const NAMESPACE = "CreateOrderModalCustomer";

export const SEARCH_BAR_INSTANCE = "createOrderModalCustomerSearchBar";

export const SEARCH_BAR_INSTANCE_CONTACTS =
  "createOrderModalCustomerSearchBarContacts";
